import React from "react"
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faSignOutAlt } from "@fortawesome/free-solid-svg-icons"

import HeadMenu from "./HeadMenu"
import ErrorBoundary from "../ErrorBoundary"

import './../css/navbar-dropdown-menu.css'
import abLogo from "../img/ab_logo_bw.png"
import msLogo from "../img/MSSurfaceLogo.png"

const useStyles = makeStyles(() => ({
    textRed: {
        color: 'red',
    },
    logoWrap: {
        maxHeight: '70px',
    },
}))

export function Navbar(props) {
    const classes = useStyles()

    return <nav className="navbar navbar-expand-lg">
        <div className="float-left">
            <a data-activates="slide-out" className="button-collapse black-text"><FontAwesomeIcon icon={faBars}/></a>
        </div>
        <div className="collapse navbar-collapse" id="navbarTop">
            <ErrorBoundary>
                <div>
                    <img src={abLogo} alt="AB S.A. logo" className={classes.logoABWrap} />
                </div>
                <div>
                    <img src={msLogo} alt="Microsoft Surface logo" className={classes.logoWrap} />
                </div>
                <ul style={{minHeight: '2rem', paddingTop: '.4rem'}} className='navbar-nav mr-auto'>
                    <HeadMenu type='main'/>
                </ul>
                <span style={{color: '#fff', margin: '0 1em'}}>
                    {props.mfgId}
                </span>
                <button type="submit" className="btn-logout" onClick={props.clickLogOut}>
                    <FontAwesomeIcon icon={faSignOutAlt}/>
                </button>
            </ErrorBoundary>
        </div>
    </nav>
}

Navbar.propTypes = {
    mfgId: PropTypes.string,
    clickLogOut: PropTypes.func
}

export default Navbar
